import { Buffer } from 'buffer';
import { Md5 } from 'ts-md5';

export type GenderProps = 'male' | 'female';

type searchParamsObjectProps = {
  patientId?: string;
  signature?: string;
  firstname: string;
  gender: GenderProps;
  phone?: string;
  country_code?: string;
  email?: string;
  birthday: string;
};

interface generateTeladocUrlProps {
  baseUrl: string;
  policyNumber: string;
  memberId: string;
  memberType: string;
  firstName: string;
  lastName: string;
  gender: GenderProps;
  birthDate: string;
  email: string;
  countryCode: string;
  phone?: string;
  languageCode: string;
  signingKey: string;
}

const generateSignature = (id: string, signingKey: string): string => {
  const hashedSignature = Md5.hashStr(`${id}${signingKey}`);
  const base64Signature = Buffer.from(hashedSignature, 'utf-8').toString('base64');
  return base64Signature;
};

// Logic based on getCallADocLink() in wecare-web-app
// https://bitbucket.org/generali-hk/wecare-web-app/src/39fd78ff1f6b7b7c49606717c270207adee1b67a/src/java/generali/userview.java?at=master#lines-2940
export const generateTeladocUrl = ({
  baseUrl,
  policyNumber,
  memberId,
  memberType,
  firstName,
  lastName,
  gender = 'female',
  birthDate,
  email,
  countryCode,
  phone,
  languageCode,
  signingKey,
}: generateTeladocUrlProps): string => {
  const patientId = `${policyNumber}-${memberId}-${memberType}`;

  const idStartCharacters = patientId.slice(0, 3);
  const idEndCharacters = patientId.slice(-3);
  const fullName = firstName + lastName;

  //ITREQ-4940 Sort By ASCII character
  const searchParamsObject: searchParamsObjectProps = {
    birthday: birthDate,
    country_code: countryCode,
    email,
    firstname: fullName.trim(),
    gender,
    phone,
  };

  const searchParamsObjectWithoutNulls = Object.fromEntries(
    Object.entries(searchParamsObject).filter(([, value]) => !['null', 'undefined'].includes(value + '')),
  );

  const searchParamsString = new URLSearchParams(searchParamsObjectWithoutNulls).toString();
  //ITREQ-4940 New Teledoc URL Encryption Requirement
  const signature = {
    patientId: patientId,
    signature: generateSignature(`${idStartCharacters}${idEndCharacters}${patientId}${searchParamsString}`, signingKey),
  };
  const signatureSearchParamsString = new URLSearchParams(signature).toString();

  return `${baseUrl}/${languageCode}?${searchParamsString}&${signatureSearchParamsString}`;
};
